<template>
  <div class="fs-adjustments">
    <fs-range-filter-wrapper min="-1" max="1" defaultValue="0" :routerLink="'/adjustments'" v-model="value.brightness" label="menu.brightness"/>
  </div>
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator';
import { Adjustments } from '@filestack/canvas-sdk';

import { FilterMixin } from './FilterMixin';

@Component
class Brightness extends FilterMixin {

  protected filter = new Adjustments.Brightness();

  protected value = { brightness: 0 };
}

export default Brightness;
</script>
